import styled from 'styled-components';
import {baseButtonStyles} from '../../components/button';
import {Link} from '@reach/router';

interface OwnProps {
    whiteBackground?: boolean;
}

export const HugeLink = styled(Link)`
    ${baseButtonStyles}

    font-size: 1.3em;
    width: 100%;
    height: 72px;
    margin: 10px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.15);
    background-color: ${(props: OwnProps) => (props.whiteBackground === true ? '#ffffff' : '#00c9ff')};

    &:hover,
    &:active,
    &:focus {
        background-color: ${(props: OwnProps) => (props.whiteBackground === true ? '#ffffff' : '#00c9ff')};
    }

    &:focus {
        box-shadow: 0 0 0 0.2rem
            ${(props: OwnProps) =>
                props.whiteBackground === true ? 'rgba(255,255,255,0.5)' : 'rgba(0, 201, 255, 0.5)'};
    }

    span {
        color: ${(props: OwnProps) => (props.whiteBackground === true ? '#00c9ff' : '#ffffff')};
    }
`;
